import { Box, Flex, Text, Input, Image, Badge, InputGroup, InputLeftElement, Popover, PopoverTrigger, PopoverContent, Button, PopoverBody, useDisclosure, Table, Thead, Tbody, Tr, Th, Td, TableContainer, PopoverCloseButton, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, Grid, GridItem, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Center, Spinner, Select, HStack, Tooltip, IconButton, } from '@chakra-ui/react';
import MyDiv from './activeJobs.style';
import FilterIcon from '../../../../assets/images/Filter.svg';
import SortIcon from '../../../../assets/images/SortIcon.svg';
import { CopyIcon, ExternalLinkIcon, SearchIcon, ViewIcon } from '@chakra-ui/icons';
import { useEffect, useState, useRef } from 'react';
import { ActionEditIcon, CustomButton, CustomPagination, CustomTable, CustomToast, FilterPopover } from '../../../../components';
import { useNavigate } from "react-router";
import * as routesNames from '../../../../constants/routes';
import { NewJobOpeningCard, CloneJobOpening } from '../components';
import { ILazyParams, useFetch } from '../../../../hooks/useFetch';
import { IFilterOptions } from '../../../../components/FilterCard/filterCard';
import { Column } from '../../../../components/CustomTable/customTable';
// import facebook from "../../../../assets/images/facebook.svg"
// import twitter from "../../../../assets/images/twitter.svg"
// import email from "../../../../assets/images/email.svg"
// import whatsapp from "../../../../assets/images/whatsapp.svg"
import GenerateQrModal from '../components/JobQrCode/GenerateQrModal';
import { showDate } from '../../../../utilities/helper';


const sortOptions = [
  'Job Title (A–Z)',
  'Job Title (Z–A)',
  'Department (A–Z)',
  'Department (Z–A)',
  'Created At- Newest First',
  'Created At- Oldest First',
];

const sortMapping: Record<string, { field: string; order: 1 | -1 }> = {
  'Job Title (A–Z)': { field: 'job_Profile_Name', order: 1 },
  'Job Title (Z–A)': { field: 'job_Profile_Name', order: -1 },
  'Department (A–Z)': { field: 'department_Name', order: 1 },
  'Department (Z–A)': { field: 'department_Name', order: -1 },
  'Created At- Newest First': { field: 'job_Code', order: -1 },
  'Created At- Oldest First': { field: 'job_Code', order: 1 },
};
export const HeaderWithTooltip = ({ short, full, }: { short: string; full: string; }) => (
  <Tooltip label={full} hasArrow>
    <Text className='font-poppins text_medium text_sm' textAlign="center" cursor="help" whiteSpace="nowrap" >
      {short}
    </Text>
  </Tooltip>
);


const ActiveJobs = () => {
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [reload, setReload] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selected, setSelected] = useState<string>(sortOptions[0]);
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [cloneDrawerOpen, setCloneDrawerOpen] = useState(false);
  const [cloningJob, setCloningJob] = useState<any | null>(null);
  const [editingJob, setEditingJob] = useState<any | null>(null);
  const [jobOpenings, setJobOpenings] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [selectedJD, setSelectedJD] = useState<string>('');
  const [textSearch, setTextSearch] = useState<string>("");
  const [isQrModalOpen, setIsQrModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState<any>(null);

  const [pendingDrafts, setPendingDrafts] = useState<any[]>([]);
  const [draftPickerOpen, setDraftPickerOpen] = useState(false);
  const [draftLoading, setDraftLoading] = useState(false);


  // const [selectedJobs, setSelectedJobs] = useState<number[]>([]);
  // const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [filter, setFilter] = useState<IFilterOptions>({ filterOptions: {} });


  const jobCardRef = useRef<{ attemptClose: () => void }>(null);

  const [query, setQuery] = useState<{ lazyParams: ILazyParams, filter?: Record<string, number[]>; }>({
    lazyParams: { first: 0, rows: 20, page: 0, sortField: '', sortOrder: 1 },
    filter: {},
  });

  const pageCount = Math.ceil(totalCount / query.lazyParams.rows);
  const handlePageClick = ({ selected }: { selected: number }) => {
    setQuery(prev => {
      const updatedParams = {
        ...prev.lazyParams,
        page: selected,
        first: selected * prev.lazyParams.rows,
      };
      return { ...prev, lazyParams: updatedParams };
    });
  };

  const setRowsPerPage = (rows: number) => {
    setQuery((prev) => {
      const updatedParams = {
        ...prev.lazyParams,
        rows,
        page: 0,
        first: 0,
      };
      return { ...prev, lazyParams: updatedParams };
    });
  };

  const checkDrafts = async (): Promise<any[]> => {
    const res = await fetchApi("JobOpening/MyDrafts", "GET", null, "", "");
    return res || [];
  };

  
  const handleSelectDraft = async (draft: any) => {
    setDraftLoading(true);
    const fullDraft = await fetchApi("JobOpening/Draft/" + draft.id, "GET", null, "", "");
    setDraftLoading(false);
    if (fullDraft) {
      setEditingJob(fullDraft);
      setDraftPickerOpen(false);
      setDrawerOpen(true);
    }
  };

  async function loadEmployeeFilter() {
    const response = await fetchApi<IFilterOptions>('Filters/OpenJobFilter', 'GET', null, null, '');
    if (response) {
      setFilter(response);
    }
  }

  const handleEdit = (job: any) => {
    setEditingJob(job);
    setDrawerOpen(true);
  };

  const handleCloneJob = (job: any) => {
    setCloningJob(job);
    setCloneDrawerOpen(true);
  };

  const handleCloseCloneDrawer = () => {
    setCloneDrawerOpen(false);
    setCloningJob(null);
  };

  const handleSelect = (option: string) => {
    setSelected(option);
    const sortConfig = sortMapping[option];
    if (sortConfig) {
      setQuery(prev => ({
        ...prev,
        lazyParams: {
          ...prev.lazyParams,
          sortField: sortConfig.field,
          sortOrder: sortConfig.order,
          page: 0,
          first: 0
        }
      }));
    }
    onClose();
  };

  const handleStatusChange = async (row: any, newStatus: string) => {
    try {
      const updatedStatus = newStatus === "Active";
      setJobOpenings(prevJobs =>
        prevJobs.map(job =>
          job.id === row.id ? { ...job, status: updatedStatus } : job
        )
      );

      const payload = {
        id: row.id,
        status: updatedStatus,
      };

      const res = await fetchApi("JobOpening/StatusUpdate", "PUT", payload, "", `Job marked as ${newStatus}`);

      if (res) {
        loadActiveJob();
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };


  const candidateList = (job: any, type?: string) => {
    navigate(routesNames.CANDIDATELIST, {
      state: {
        jobId: job.id,
        jobProfile: job.job_Profile_Name,
        filterType: type,
      },
    });
  };


  const handleOpenJD = (jd: string) => {
    setSelectedJD(jd);
    onOpen();
  };

  const loadActiveJob = async (filterValue = '') => {
    const queryParams = new URLSearchParams({
      lazyParams: JSON.stringify(query.lazyParams),
      status: "true",
      filter: JSON.stringify(query.filter ?? {}),
      search: filterValue.trim() === "" ? "" : filterValue,
    })

    const response = await fetchApi("JobOpening", "GET", null, queryParams.toString(), "");
    if (response) {
      setJobOpenings(response.data);
      setTotalCount(response.totalCount);
    }
  }
  useEffect(() => {
    loadActiveJob();
  }, [query.lazyParams, reload])

  useEffect(() => {
    loadEmployeeFilter();
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      loadActiveJob(textSearch);
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [textSearch]);

  const openQrModal = (row: any) => {
    setSelectedJob(row);
    setIsQrModalOpen(true);
  };

  const closeQrModal = () => {
    setIsQrModalOpen(false);
  };

  useEffect(() => {
    if (!drawerOpen) setEditingJob(null);
  }, [drawerOpen]);

  const handleCreateClick = async () => {
    const drafts = await checkDrafts();
    if (drafts.length > 0) {
      setPendingDrafts(drafts);
      setDraftPickerOpen(true);
    } else {
      setEditingJob(null);
      setDrawerOpen(true);
    }
  };


  return (
    <MyDiv>
      <Grid className='grid_container'>
        <GridItem colSpan={12}>
          <Box className="page_wrapper ">
            <Flex className="page_heading flex_header">
              <Text className="font-poppins text_3xl text_semibold">Job Openings</Text>
              <Flex className="filter_section">
                <InputGroup maxW="200px">
                  <InputLeftElement pointerEvents="none">
                    <SearchIcon color="gray.400" />
                  </InputLeftElement>
                  <Input placeholder="Search Jobs" onChange={(e) => setTextSearch(e.target.value)} />
                </InputGroup>

                <Popover placement="bottom-end" closeOnBlur>
                  <PopoverTrigger>
                    <Image src={FilterIcon} alt="Filter" className='icon_btn' />
                  </PopoverTrigger>
                  <FilterPopover filter={filter} onApplyFilter={(filters) => {
                    const _filter: Record<string, number[]> = {};
                    Object.keys(filters).forEach((key) => {
                      if (filters[key].length > 0) {
                        _filter[key.replace(' ', '')] = filters[key];
                      }
                    });
                    setQuery(prev => { return { ...prev, lazyParams: { ...prev.lazyParams, page: 0, first: 0 }, filter: _filter }; });
                  }}
                  />

                </Popover>

                <Popover placement="bottom-end" closeOnBlur>
                  <PopoverTrigger>
                    <Image src={SortIcon} alt="Sort" className='icon_btn' />
                  </PopoverTrigger>
                  <PopoverContent w="270px" borderRadius="10px" boxShadow="md" textAlign={'center'}>
                    <Box px={4} py={2} borderBottom="1px solid #eee">
                      <Text className='font-poppins text_sm text_medium' textAlign="center" color={"#00000080"}>Sort By</Text>
                      <PopoverCloseButton top="8px" right="12px" />
                    </Box>
                    <PopoverBody p={0}>
                      {sortOptions.map((option) => (
                        <Box key={option} px={4} py={2} cursor="pointer" bg={selected === option ? '#EBEBEB' : 'white'} _hover={{ bg: '#EBEBEB' }}
                          onClick={() => handleSelect(option)}
                        >
                          <Text className='font-poppins font_dark' fontSize="14px" fontWeight="500">{option}</Text>
                        </Box>
                      ))}
                    </PopoverBody>
                  </PopoverContent>
                </Popover>

                {/* <CustomButton title="Create New Job Opening" className=" btn font-poppins text_sm text_medium" onClick={() => setDrawerOpen(true)} /> */}

                <CustomButton title="Create New Job Opening" className=" btn font-poppins text_sm text_medium" onClick={handleCreateClick} />
                {/* {selectedJobs.length > 0 && (
                  <CustomButton title="Share Job" className="btn font-poppins text_sm text_medium" onClick={() => setIsShareModalOpen(true)}/>
                )} */}
              </Flex>
            </Flex>

            <Box position="relative" minH="300px">
              {loading ? (
                <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                  <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                </Center>
              ) : (
                <>
                  <CustomTable value={jobOpenings} >
                    {/* <Column
                          header={
                            <input
                              type="checkbox"
                              style={{ cursor: "pointer" }}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                if (checked) {
                                  setSelectedJobs(jobOpenings.map((job) => job.id));
                                } else {
                                  setSelectedJobs([]);
                                }
                              }}
                              checked={selectedJobs.length === jobOpenings.length && jobOpenings.length > 0}
                            />
                          }
                          body={(row: any) => (
                            <input
                              type="checkbox"
                              style={{ cursor: "pointer" }}
                              checked={selectedJobs.includes(row.id)}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setSelectedJobs((prev) =>
                                  checked ? [...prev, row.id] : prev.filter((id) => id !== row.id)
                                );
                              }}
                            />
                          )}
                        /> */}
                    {/* <Column header="S. No" body={(_, index) => index + 1} /> */}
                    <Column header="Job Code" field="job_Code" body={(row: any) => (
                      <Button variant="link" className="job font-poppins text_sm text_regular" size="sm" colorScheme="blue" onClick={() => candidateList(row)}>
                        {row.job_Code}
                      </Button>
                    )} />
                    <Column header="Job Titles" body={(row: any) => (
                      <Badge variant="subtle" className="job font-poppins text_sm text_regular" onClick={() => handleOpenJD(row.jd_Description)}>
                        {row.job_Profile_Name}
                      </Badge>
                    )}
                    />

                    <Column header="Payroll Company" field="payroll_Company_Name" />
                    <Column header="Company" field="company_Name" />
                    <Column header="Branch" field="branch_Name" />
                    <Column header="Department" field="business_Process_Name" />
                    <Column header={<HeaderWithTooltip short="S.Department" full="Sub Department" />} field="department_Name" />
                    <Column header={<HeaderWithTooltip short="Open." full="Number of Openings" />} field="number_Of_Openings" />
                    <Column header={<HeaderWithTooltip short="Appl." full="Applied Candidates" />} body={(row: any) => (
                      <Text color="blue.500" fontWeight="500" fontSize="14px" cursor="pointer" textDecor="underline" onClick={() => candidateList(row, "applied")}>
                        {row.appliedCount}
                      </Text>
                    )}
                    />
                    <Column header={<HeaderWithTooltip short="Int." full="Interviewed Candidates" />} body={(row: any) => (
                      <Text color="blue.500" fontWeight="500" fontSize="14px" cursor="pointer" textDecor="underline" onClick={() => candidateList(row, "interviewed")}>
                        {row.interviewCount}
                      </Text>
                    )}
                    />
                    <Column header={<HeaderWithTooltip short="LOI." full="Loi Sent" />} body={(row: any) => (
                      <Text color="blue.500" fontWeight="500" fontSize="14px" cursor="pointer" textDecor="underline" onClick={() => candidateList(row, "loiSent")}>
                        {row.loiCount}
                      </Text>
                    )}
                    />
                    <Column header={<HeaderWithTooltip short="Acc." full="Accepted Candidates" />} body={(row: any) => (
                      <Text color="blue.500" fontWeight="500" fontSize="14px" cursor="pointer" textDecor="underline" onClick={() => candidateList(row, "acceptedCount")}>
                        {row.acceptedCount}
                      </Text>
                    )}
                    />
                    <Column header={<HeaderWithTooltip short="Joi." full="Joined Candidates" />} body={(row: any) => (
                      <Text color="blue.500" fontWeight="500" fontSize="14px" cursor="pointer" textDecor="underline" onClick={() => candidateList(row, "joined")}>
                        {row.joinedCount}
                      </Text>
                    )}
                    /><Column header={<HeaderWithTooltip short="Back." full="Backout Candidates" />} body={(row: any) => (
                      <Text color="blue.500" fontWeight="500" fontSize="14px" cursor="pointer" textDecor="underline" onClick={() => candidateList(row, "backout")}>
                        {row.backoutCount}
                      </Text>
                    )}
                    />
                    <Column header="Status" body={(row: any) => (
                      <Box display="flex" alignItems="center" justifyContent="center" w="full">
                        <Select size="sm" width="99px" borderRadius="6px" border="1px solid #ccc" bg={row.status ? '#E5F2E5' : '#ffe5e5ff'} color={row.status ? '#008000' : '#d43434ff'} fontSize="12px" fontWeight="400" className="font-poppins" value={row.status ? 'Active' : 'Closed'} onChange={(e) => handleStatusChange(row, e.target.value)} _focus={{ boxShadow: 'none', outline: 'none' }} _hover={{ cursor: 'pointer' }}>
                          <option style={{ color: '#008000' }} value="Active">
                            Active
                          </option>
                          <option style={{ color: '#FFA500' }} value="Closed">
                            Closed
                          </option>
                        </Select>
                      </Box>
                    )} />
                    <Column header={<HeaderWithTooltip short="O.Date" full="Job Opening Date" />} body={(row) => showDate(row.job_Opening_Date)} field='job_Opening_Date' />
                    <Column header={<HeaderWithTooltip short="C.Date" full="Job Closing Date" />} body={(row) => showDate(row.job_Closing_Date)} field='job_Closing_Date' />
                    <Column header={<HeaderWithTooltip short="By" full="Created By" />} field="created_By" />
                    <Column header={<HeaderWithTooltip short="On" full="Created At" />} field='createdAt' body={r => showDate(r.createdAt)} />
                    <Column header={<Text textAlign="center" fontSize="sm" fontWeight="500"> Actions </Text>}
                      body={(row: any) => (
                        <HStack spacing={1} justify="center">
                          <Tooltip label="Edit Job Opening" hasArrow>
                            <ActionEditIcon onClick={() => handleEdit(row)} />
                          </Tooltip>
                          <Tooltip label="Clone Job Opening" hasArrow>
                            <IconButton aria-label="Clone Job" icon={<CopyIcon />} size="sm" variant="ghost" onClick={() => handleCloneJob(row)} />
                          </Tooltip>
                          <Tooltip label="Generate Job QR Code" hasArrow>
                            <IconButton aria-label="Generate QR Code" icon={<ExternalLinkIcon />} size="sm" variant="ghost" colorScheme="green" onClick={() => openQrModal(row)} />
                          </Tooltip>
                        </HStack>
                      )}
                    />
                  </CustomTable>

                </>)}
            </Box>
            <CustomPagination pageCount={pageCount} handlePageClick={handlePageClick} rowsPerPage={query.lazyParams.rows} setRowsPerPage={setRowsPerPage} totalRecords={totalCount} currentPage={query.lazyParams.page} rowsPerPageOptions={[20, 50, 200, 500]} />
          </Box>
        </GridItem>
      </Grid>

      <Drawer isOpen={drawerOpen} placement="right" onClose={() => jobCardRef.current?.attemptClose()} size="xl">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton onClick={() => jobCardRef.current?.attemptClose()} />
          <DrawerHeader borderBottomWidth="1px">
            {editingJob ? "Edit New Job Opening" : "Create New Job Opening"}
          </DrawerHeader>
          <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
            <NewJobOpeningCard ref={jobCardRef} jobData={editingJob} handleDrawer={setDrawerOpen} loadJobOpening={loadActiveJob} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <Drawer isOpen={cloneDrawerOpen} placement="right" onClose={handleCloseCloneDrawer} size="lg">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">Clone Job Opening</DrawerHeader>
          <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
            <CloneJobOpening jobData={cloningJob} handleDrawer={setCloneDrawerOpen} loadJobOpening={loadActiveJob} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <Modal isOpen={isOpen} onClose={onClose} size="5xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Job Description</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div className="font-poppins text_regular text_md" style={{ whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: selectedJD || "" }} />
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose} colorScheme="green">Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={draftPickerOpen} onClose={() => setDraftPickerOpen(false)} isCentered size="md">
        <ModalOverlay />
        <ModalContent borderRadius="lg">
          <ModalHeader>Pending Draft{pendingDrafts.length > 1 ? "s" : ""} Found</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text mb={3} fontSize="14px" color="#64748B">
              You have unfinished job draft{pendingDrafts.length > 1 ? "s" : ""}. Resume one, or start a new job opening.
            </Text>
            <Flex direction="column" gap={2} maxH="300px" overflowY="auto">
              {pendingDrafts.map((d) => (
                <Flex
                  key={d.id}
                  border="1px solid #E2E8F0"
                  borderRadius="8px"
                  px={3}
                  py={2}
                  justify="space-between"
                  align="center"
                  cursor="pointer"
                  _hover={{ bg: "#F0FDF4" }}
                  opacity={draftLoading ? 0.6 : 1}
                  pointerEvents={draftLoading ? "none" : "auto"}
                  onClick={() => handleSelectDraft(d)}
                >
                  <Box>
                    <Text fontWeight="600" fontSize="14px">{d.job_Profile_Name || "Untitled Draft"}</Text>
                    <Text fontSize="12px" color="#94A3B8">{d.job_Code} · {showDate(d.createdAt)}</Text>
                  </Box>
                  <Text fontSize="12px" color="#006838" fontWeight="600">Resume →</Text>
                </Flex>
              ))}
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="ghost"
              onClick={() => {
                setDraftPickerOpen(false);
                setEditingJob(null);
                setDrawerOpen(true);
              }}
            >
              Start New Instead
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <GenerateQrModal isOpen={isQrModalOpen} onClose={closeQrModal} jobData={selectedJob} />
    </MyDiv>
  );
};

export default ActiveJobs;